import * as angular from "angular";
import {IController} from "angular";

export class planningRoutesTableRowCtrl implements IController {

  paymentMethod: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.billing-accounts')
  .component('paymentMethodsTableRow', {
    require: {
      paymentMethodsTableCtrl: '^paymentMethodsTable'
    },
    bindings: {
      paymentMethod: '<'
    },
    template: require('./payment-methods-table-row.html').default,
    controller: planningRoutesTableRowCtrl
  });
